// const API_BASE_URL = "http://localhost:5500";
const API_BASE_URL = "https://api.pureprakruti.com";

export default API_BASE_URL;